import { normalizePhoneForFullSearch } from "@shared/helpers/normalize-phone-for-search";

/** Super admins with extended statistics: all managers' matches and manual matches. */
const PRIVILEGED_STATISTICS_MANAGER_PHONES = [
  "+972547377155",
  "+972509157171",
] as const;

function isPrivilegedStatisticsManager(
  phoneNumber: string | null | undefined,
): boolean {
  if (!phoneNumber) return false;
  const canonical = normalizePhoneForFullSearch(phoneNumber);
  return PRIVILEGED_STATISTICS_MANAGER_PHONES.some(
    (allowed) => normalizePhoneForFullSearch(allowed) === canonical,
  );
}

/** Synthetic series id for org-wide manual matches in daily match charts. */
export const GENERAL_MANUAL_MATCHES_SERIES_ID = "__general_manual__";

export const GENERAL_MANUAL_MATCHES_SERIES_NAME = "ידני כללי";

export function canViewAllManagersMatchStats(
  phoneNumber: string | null | undefined,
): boolean {
  return isPrivilegedStatisticsManager(phoneNumber);
}

export function canManageManualMatches(
  phoneNumber: string | null | undefined,
): boolean {
  return isPrivilegedStatisticsManager(phoneNumber);
}
